/* @flow */
import moment from 'moment';

import Td from 'components/UIKit/Table/Td';
import ParamsLink from 'components/Links/ParamsLink';
import AnnotationIcon from 'components/icons/AnnotationIcon';
// $FlowIgnore
import _ from 'lodash';
import TrLink from '../TrLink';

type AnnotationsRowProps = {
  router: Object,
  children: any
}

export default function AnnotationsRow({
  children, router,
}: AnnotationsRowProps): React.Element {
  const link = ((children._links || [])[0] || {});
  const entityType = link.type;
  const entitySubmitterID = link.submitter_id;
  const newQuery = { did: children.id };
  const isActiveItem = children.id
    && (router.location.query.did === children.id);

  return (
    <TrLink
      isActiveItem={isActiveItem}
      linkId={children.id}
      router={router}
      >
      <Td>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <AnnotationIcon style={{ marginRight: '.5rem' }} />
          {isActiveItem ? children.submitter_id : (
            <ParamsLink customDataTestID="text-submitter-id" query={newQuery}>
              { children.submitter_id }
            </ParamsLink>
          )}
        </div>
      </Td>
      <Td customDataTestID="text-category" >{ children.category || '' }</Td>
      <Td customDataTestID="text-entity-type">{ _.startCase(entityType) }</Td>
      <Td customDataTestID="text-entity-submitter-id">{ entitySubmitterID }</Td>
      <Td customDataTestID="text-last-updated">{ moment(children.updated_datetime).format('ll') }</Td>
    </TrLink>
  );
}
